<template>
	<div :class="classes" class="w-full">
		<div
			:class="[styling.includes('box') ? 'px-3 py-5' : 'container justify-center', bannerPadding]"
			class="flex flex-col items-center"
		>
			<p class="text-center bigger text-white max-w-4xl">
				<slot name="headline" />
			</p>
			<HokButton
				v-if="hasSlotButton"
				name="cta-button"
				:size="btnsize"
				:color="btncolor"
				:invisible="btnInvisible"
				:to="enableLink ? (to ? to : btnlink) : ''"
				target="_self"
				:font-weight="styling.includes('box') ? 'normal' : 'bold'"
				@click="$emit('cta-click')"
				><slot name="button" />
			</HokButton>
			<slot name="custom" />
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HokButton from './HokButton.vue';

export default defineComponent({
	name: 'CallToAction',
	components: { HokButton },
	emits: ['cta-click'],
	data() {
		const classes: string[] = [];

		return {
			classes,
			btncolor: '',
			btnlink: '',
			btnsize: '',
			bannerPadding: '',
			btnInvisible: false
		};
	},
	computed: {
		hasSlotButton() {
			return !!this.$slots.button;
		}
	},
	created() {
		switch (this.styling) {
			case 'default':
			case 'user-banner':
				this.classes = ['bg-coral'];
				this.btnlink = '/app/login';
				this.btnInvisible = true;
				this.btncolor = 'white-text';
				this.btnsize = 'medium';
				this.bannerPadding = 'py-6';
				break;
			case 'user-box':
				this.classes = ['bg-main', 'rounded-lg'];
				this.btnlink = '/app/login';
				this.btnInvisible = true;
				this.btncolor = 'white-text';
				this.btnsize = 'medium';
				break;
			case 'company-banner':
				this.classes = ['bg-main'];
				this.btnlink = '/business';
				this.btncolor = 'yellow';
				this.btnsize = 'big';
				this.bannerPadding = 'py-8';
				break;
			case 'company-box':
				this.classes = ['bg-main', 'rounded-lg'];
				this.btnlink = '/business';
				this.btncolor = 'yellow';
				this.btnsize = 'medium';
				break;
			case 'neutral-banner':
				this.classes = ['bg-blue-grey'];
				this.btnlink = '/app/login';
				this.btnInvisible = true;
				this.btncolor = 'white-text';
				this.btnsize = 'big';
				this.bannerPadding = 'py-8';
				break;
			case 'international-banner':
				this.classes = ['bg-landing-banner'];
				this.btnlink = '/app/login';
				this.btnInvisible = true;
				this.btncolor = 'main';
				this.btnsize = 'medium';
				this.bannerPadding = 'py-6';
				break;
			default:
				break;
		}
	},
	props: {
		to: { type: String, required: false },
		enableLink: { type: Boolean, required: false, default: true },
		styling: {
			type: String,
			default: 'banner',
			validator: (value: string) =>
				['user-banner', 'user-box', 'company-banner', 'company-box', 'neutral-banner'].includes(
					value
				)
		}
	}
});
</script>
